import React, { useRef } from "react";
import { Spinner, Row, Col, Pagination } from "react-bootstrap";
import { dateDiff } from "../../../../_helpers/dateFormatter";
import EmptyFeedCard from "../../../../_uiComponents/EmptyFeedCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faChartSimple,
  faLayerGroup,
  faSackDollar,
} from "@fortawesome/free-solid-svg-icons";

function JobSearch({
  jobSearch,
  jobLoading,
  handleClose,
  onViewCompany,
  formSubmitError,
  onJobCardClick,
  activeJobCard,
  jobCardDivParentRef,
  currentPage,
  onCurrentPageChange,
  jobDetailsLoading,
}) {
  const scrollToCardRef = useRef(null);

  if (activeJobCard) {
    if (scrollToCardRef?.current) {
      let topPos =
        scrollToCardRef?.current && scrollToCardRef.current?.offsetTop;
      jobCardDivParentRef?.current &&
        jobCardDivParentRef.current.scrollTo({
          top: topPos,
          behavior: "smooth",
        });
    }
  }

  return (
    <div>
      {jobLoading ? (
        <div className="d-flex justify-content-center align-items-center w-100">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : Array.isArray(jobSearch) && jobSearch && jobSearch.length ? (
        Array.isArray(jobSearch) &&
        jobSearch.map((item) => (
          <Row>
            <Col md={3} className="">
              <div className="filter-list">
                <div className=" p-3 bg-grey border-radius-10 border">
                  <div className="d-flex font-weight-medium flex-wrap justify-content-between align-items-center mb-4">
                    <h3 className="font-weight-medium">Experience Level</h3>
                    <p className="text-primary mb-0">Clear</p>
                  </div>
                  <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="rememberCheck"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rememberCheck"
                      >
                        Entry Level
                      </label>
                    </div>

                    <p className="text-muted">255 jobs</p>
                  </div>
                  <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="rememberCheck"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rememberCheck"
                      >
                        Intermediate
                      </label>
                    </div>

                    <p className="text-muted">124 jobs</p>
                  </div>
                  <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="rememberCheck"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rememberCheck"
                      >
                        Expert
                      </label>
                    </div>

                    <p className="text-muted">2404 jobs</p>
                  </div>
                </div>
                <div className=" p-3 bg-grey border-radius-10 border mt-3">
                  <div className="d-flex font-weight-medium flex-wrap justify-content-between align-items-center mb-4">
                    <h3 className="font-weight-medium">Job Location</h3>
                    <p className="text-primary mb-0">Clear</p>
                  </div>
                  <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="rememberCheck"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rememberCheck"
                      >
                        On site
                      </label>
                    </div>

                    <p className="text-muted">255 jobs</p>
                  </div>
                  <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="rememberCheck"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rememberCheck"
                      >
                        Remote
                      </label>
                    </div>
                    <p className="text-muted">2404 jobs</p>
                  </div>
                </div>

                <div className=" p-3 bg-grey border-radius-10 border mt-3">
                  <div className="d-flex font-weight-medium flex-wrap justify-content-between align-items-center mb-4">
                    <h3 className="font-weight-medium">Job type</h3>
                    <p className="text-primary mb-0">Clear</p>
                  </div>
                  <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="rememberCheck"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rememberCheck"
                      >
                        Full time
                      </label>
                    </div>

                    <p className="text-muted">255 jobs</p>
                  </div>
                  <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="rememberCheck"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rememberCheck"
                      >
                        Part time
                      </label>
                    </div>

                    <p className="text-muted">2404 jobs</p>
                  </div>
                  <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="rememberCheck"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="rememberCheck"
                      >
                        Contract
                      </label>
                    </div>

                    <p className="text-muted">2404 jobs</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3} className="order-2 order-md-1">
              <div className="job-cards-list" ref={jobCardDivParentRef}>
                <div
                  className={`job-box px-4 my-0 mb-3 py-3 border-radius-10 ${
                    activeJobCard ? "active" : ""
                  }`}
                  onClick={() => onJobCardClick(item?.id)}
                  ref={scrollToCardRef}
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-start justify-content-beetween">
                      <img
                        src={
                          item?.posted_by_details &&
                          item.posted_by_details?.company_details &&
                          item.posted_by_details.company_details?.logo === null
                            ? "/assets/images/company-logo-placeholder.png"
                            : item?.posted_by_details &&
                              item.posted_by_details?.company_details &&
                              item.posted_by_details.company_details?.logo
                        }
                        alt="company logo"
                        className="border-radius-10 mr-3"
                        style={{ width: "60px", height: "60px" }}
                      />
                      <div className="job-info ml-3">
                        <h3 className="text-primary mb-1 text-capitalize">
                          {item?.title}
                        </h3>
                        <p className="text-grey-4 mb-1">
                          {item?.posted_by_details &&
                            item.posted_by_details?.company_details &&
                            item.posted_by_details.company_details?.name}
                        </p>
                        <p className="text-grey-4">
                          <span className="text-capitalize">
                            {item?.state_name},{" "}
                          </span>
                          <span className="text-uppercase">
                            {item?.country_name}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-end">
                    <ul className="d-flex tags flex-wrap text-capitalize">
                      <li className="mr-1 text-primary rounded px-2 py-1 mr-2 mt-2">
                        {item?.employment_type &&
                          item.employment_type?.replace(/_/g, " ")}
                      </li>
                      <li className="mx-1 text-primary rounded px-2 py-1 mr-2 mt-2">
                        {item?.experience &&
                          item.experience?.replace(/_/g, " ")}
                      </li>
                    </ul>
                    <span className="text-primary fs-smallest ">
                      Posted {dateDiff(item.created, new Date())} ago
                    </span>
                  </div>
                </div>
              </div>
              {jobSearch && (
                <Pagination
                  pageSize={10}
                  current={currentPage}
                  total={jobSearch?.count}
                  onChange={onCurrentPageChange}
                  style={{
                    bottom: "0px",
                    textAlign: "center",
                    marginTop: 20,
                  }}
                />
              )}
            </Col>
            <Col md={6} className="order-1 order-md-2">
              {jobDetailsLoading ? (
                <div className="d-flex justify-content-center align-items-center w-100">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <div className="job-expanded-info bg-grey-3 px-4 h-100">
                  <div className="bottom position-relative">
                    <div className="job-meta d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center flex-1">
                        <img
                          src={
                            item?.posted_by_details &&
                            item?.posted_by_details?.company_details &&
                            item.posted_by_details.company_details?.logo ===
                              null
                              ? "/assets/images/company-logo-placeholder.png"
                              : item?.posted_by_details &&
                                item?.posted_by_details?.company_details &&
                                item.posted_by_details.company_details?.logo
                          }
                          alt="company logo"
                          className="border-radius-10 mr-3 align-self-end"
                          style={{
                            width: "70px",
                            height: "70px",
                            objectFit: "cover",
                          }}
                        />
                        <div className="mt-3 text-capitalize">
                          <div className="d-inline-block">
                            <h3 className="mb-1 text-primary">{item?.title}</h3>
                            <p
                              className="text-primary mb-1 cursor-pointer font-weight-medium"
                              onClick={() =>
                                onViewCompany(
                                  item?.posted_by_details &&
                                    item.posted_by_details?.company
                                )
                              }
                            >
                              <span>
                                {item?.posted_by_details &&
                                  item.posted_by_details?.company_details &&
                                  item.posted_by_details.company_details?.name}
                              </span>
                            </p>
                            <p className="mb-0 text-grey-4">
                              <span>
                                {dateDiff(item?.created, new Date())} ago
                              </span>
                              {", "}
                              <span>{item?.total_candidates} Applicants</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="text-right">
                        <button
                          className="btn btn-primary apply px-4"
                          onClick={() => handleClose(false)}
                        >
                          Apply Now
                        </button>
                        {formSubmitError?.applied_msg && (
                          <div className="d-flex align-items-center justify-content-between">
                            <span className="text-danger font-weight-medium">
                              {formSubmitError?.applied_msg}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    <ul className="fs-smallest d-flex align-items-center mt-4 mb-3 flex-wrap">
                      <li className="py-2 flex-grow-1 d-flex align-items-center">
                        <div className="icon bg-primary rounded-pill mr-3">
                          <FontAwesomeIcon
                            icon={faSackDollar}
                            className="p-2 text-white fa-2x ml-1 mt-1"
                          />
                        </div>
                        <div>
                          <p className="mb-0 text-primary font-weight-medium text-uppercase">
                            {item?.payment_currency} {item?.payment_from}/
                            <span className="text-capitalize">
                              {item?.payment_type}
                            </span>
                          </p>
                          <p className="text-grey-4 mb-0">Salary</p>
                        </div>
                      </li>
                      <li className="py-2 flex-grow-1 d-flex align-items-center">
                        <div className="icon bg-primary rounded-pill mr-3">
                          <FontAwesomeIcon
                            icon={faLayerGroup}
                            className="p-2 text-white fa-2x ml-1 mt-1"
                          />
                        </div>
                        <div>
                          <p className="mb-0 text-primary font-weight-medium">
                            {item?.job_function}
                          </p>
                          <p className="text-grey-4 mb-0">Job Function</p>
                        </div>
                      </li>
                      <li className="py-2 flex-grow-1 d-flex align-items-center">
                        <div className="icon bg-primary rounded-pill mr-3">
                          <FontAwesomeIcon
                            icon={faBriefcase}
                            className="p-2 text-white fa-2x ml-1 mt-1"
                          />
                        </div>
                        <div>
                          <p className="mb-0 text-primary font-weight-medium">
                            Minimum{" "}
                            {item?.experience &&
                              item.experience.replace(/_/g, " ")}
                          </p>
                          <p className="text-grey-4 mb-0">Experience</p>
                        </div>
                      </li>

                      <li className="py-2 flex-grow-1 d-flex align-items-center">
                        <div className="icon bg-primary rounded-pill mr-3">
                          <FontAwesomeIcon
                            icon={faChartSimple}
                            className="p-2 text-white fa-2x ml-1 mt-1"
                          />
                        </div>
                        <div>
                          <p className="mb-0 text-primary font-weight-medium text-capitalize">
                            {item?.employment_type &&
                              item.employment_type.replace(/_/g, " ")}
                            `
                          </p>
                          <p className="text-grey-4 mb-0">Job Type</p>
                        </div>
                      </li>
                    </ul>
                    <div className="mb-3">
                      <p className="font-weight-medium">Description</p>
                      <div
                        className="text-grey-4"
                        dangerouslySetInnerHTML={{
                          __html: item?.role_description,
                        }}
                      ></div>
                    </div>
                    <div className="mb-3">
                      <p className="font-weight-medium">Requirements</p>
                      <div
                        className="text-grey-4"
                        dangerouslySetInnerHTML={{
                          __html: item?.role_requirements,
                        }}
                      ></div>
                    </div>
                    <div className="mb-3">
                      <p className="font-weight-medium">Benefits</p>
                      <div
                        className="text-grey-4"
                        dangerouslySetInnerHTML={{
                          __html: item?.role_benefits,
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        ))
      ) : (
        <EmptyFeedCard message={"no result found"} className="mt-5" />
      )}
    </div>
  );
}

export default JobSearch;
